import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Setting from "@/settings";
import Layout from "@/layouts/basic-layout";
import { Message } from "element-ui";

import util from "@/libs/util";

// 路由数据
// import routes from "./routes";
const _import = require("./_import_" + process.env.NODE_ENV); // 获取组件的方法

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

Vue.use(Router);

const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: _import("/account/login/index"),
    hidden: true,
    meta: {
      title: "登录"
    }
  },

  {
    path: "/BindingWx",
    name: "BindingWx",
    component: _import("/admin/user-operator/BindingWx"),
    hidden: true,
    meta: {
      title: "微信验证"
    }
  },
  {
    path: "/loginWx",
    name: "loginWx",
    component: _import("/account/login/loginWx"),
    hidden: true,
    meta: {
      title: "登录"
    }
  },
  {
    path: "/questionnaireLogin",
    name: "questionnaireLogin",
    component: _import("/nongcun/questionnaire/openQuestionnaire/login"),
    hidden: true,
    meta: {
      title: "问卷"
    }
  },
  {
    path: "/parentsQuestionnaire",
    name: "parentsQuestionnaire",
    component: _import("/nongcun/questionnaire/openQuestionnaire/parentsQuestionnaire"),
    hidden: true,
    meta: {
      title: "家长调查问卷"
    }
  },
  {
    path: "/stuQuestionnaire",
    name: "stuQuestionnaire",
    component: _import("/nongcun/questionnaire/openQuestionnaire/stuQuestionnaire"),
    hidden: true,
    meta: {
      title: "学生调查问卷"
    }
  },
  {
    path: "/gutQuestionnaire",
    name: "gutQuestionnaire",
    component: _import("/nongcun/questionnaire/openQuestionnaire/gutQuestionnaire"),
    hidden: true,
    meta: {
      title: "肠道菌群调查问卷"
    }
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: _import("/account/login/forgetPassword"),
    hidden: true,
    meta: {
      title: "忘记密码"
    }
  },
  {
    path: "/basicOnePrint",
    name: "basicOnePrint",
    component: _import("/nongcun/fillQuery/basicOne/print/index"),
    hidden: true,
    meta: {
      title: "表一打印页面"
    }
  },
  {
    path: "/basicTwoPrint",
    name: "basicTwoPrint",
    component: _import("/nongcun/fillQuery/basicTwo/print/index"),
    hidden: true,
    meta: {
      title: "表二打印页面"
    }
  },
  {
    path: "/tjd",
    name: "tjd",
    component: _import("/nongcun/opres/tjd/qrcode"),
    hidden: true,
    meta: {
      title: "体检单",
      auth: false
    }
  },
  {
    path: "/register",
    name: "register",
    component: _import("/register/index"),
    hidden: true,
    meta: {
      title: "电子营养师（网络版）注册申请",
      auth: false
    }
  },
  {
    path: "/retrieve",
    name: "retrieve",
    component: _import("/register/retrieve"),
    hidden: true,
    meta: {
      title: "找回密码",
      auth: false
    }
  },
  {
    path: "/showhelp",
    name: "showhelp",
    component: _import("/article/msgtip/show/index"),
    hidden: false,
    meta: {
      title: "显示帮助"
    }
  },
  {
    path: "/article/msgtip/show/index",
    name: "msgtip",
    component: _import("/article/msgtip/show/index"),
    hidden: false,
    meta: {
      title: "显示帮助"
    }
  },
  {
    path: "/article/help/show/index",
    name: "help",
    component: _import("/article/help/show/index"),
    hidden: false,
    meta: {
      title: "显示帮助"
    }
  }
];

const createRouter = () =>
  new Router({
    mode: Setting.routerMode, // require service support
    base: Setting.routerBase,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 生成路由
function generateRoutes(menus = []) {
  const routes = {
    path: "/",
    component: Layout,
    children: [],
    name: "",
    meta: {}
  };

  var bankRoutes = [];
  for (let m of menus) {
    // 资源不是菜单的，path为空的 进入下次循环
    if (m.resourceType !== 2 || !m.path || m.path === "") {
      continue;
    }
    if (!m.viewPath || m.viewPath === "") {
      continue;
    }

    let name = !m.viewName || m.viewName === "" ? m.path : m.viewName;

    let route = {
      name: name,
      path: m.path,
      meta: {
        auth: true,
        cache: m.viewCache,
        title: m.title,
        icon: m.icon,
        closable: m.closable
      }
    };

    if (m.linkType === 1) {
      route.component = _import(m.viewPath);
    } else if (m.linkType === 2) {
      if (m.openMode === 1) {
        route.component = _import("/iframe/index");
        route.meta.src = m.viewPath;
      } else {
        continue;
      }
    }

    try {
      if (m.linkType === 1 && m.openMode === 2) {
        bankRoutes.push(route);
      } else {
        routes.children.push(route);
      }
    } catch (error) {
      Message.error(`导入组件${m.viewPath}.vue失败`);
    }
  }

  var e403 = {
    path: "/403",
    name: "403",
    meta: {
      title: "403"
    },
    component: _import("/admin/error/403/index")
  };
  var e500 = {
    path: "/500",
    name: "500",
    meta: {
      title: "500"
    },
    component: _import("/admin/error/500/index")
  };
  var e404 = {
    path: "*",
    name: "404",
    meta: {
      title: "404"
    },
    component: _import("/admin/error/404/index")
  };
  routes.children.push(e403);
  routes.children.push(e500);
  routes.children.push(e404);
  return [...bankRoutes, routes];
}

// 添加路由
export function addRoutes(menus = []) {
  // 生成动态路由
  if (menus && menus.length > 0) {
    const dynamicRoutes = generateRoutes(menus);
    resetRouter();
    router.addRoutes(dynamicRoutes);
  }
}

const title = Setting.titleSuffix;
// 获取页面标题
function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return title;
}

// 刷新用户信息
var refrashUserInfo = async (to, from, next) => {
  var res = await store.dispatch("admin/account/getLoginInfo");

  if (!res) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }

  if (!res.success && res.message) {
    Message.error(res.message);
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }
  var menus = store.state.admin.user.info.menus;
  const hasPermission = menus && menus.length > 0; //验证当前用户的权限菜单下是否包含跳转的菜单,暂未实现只要有菜单就放行
  if (hasPermission) {
    next({ ...to, replace: true });
  } else {
    next({ name: "login", query: { redirect: to.fullPath } });
  }
};

let count = 0;
router.beforeEach(async (to, from, next) => {
  // 覆盖默认标题
  document.title = getPageTitle(to.meta.title);

  // count === 0 代表刷新（刷新包括：浏览器刷新和直接输入了网址进入）,这种情况下通过token重新从后台刷新数据，但排除跳转到登录页和从登录页来两个情况（原因在登录页本身就会获取最新的信息）
  // count !== 0 则代表 单页应用内正常链接跳转
  if (count === 0) {
    let noLoginPageList = ['login', 'loginWx', 'questionnaireLogin', 'parentsQuestionnaire', 'stuQuestionnaire', 'gutQuestionnaire', 'tjd', 'register', 'retrieve', 'msgtip', 'showhelp','help'];
    if (noLoginPageList.indexOf(to.name) != -1 || noLoginPageList.indexOf(from.name) != -1) {
      next();
      return;
    }
    count = 1;
    Setting.RefrashState = count;
    // Host模式 在刷新或直接输入网址进入 需验证HOST和存储的是否一致
    console.log("src>router>index.js", "Setting.tenantMode=", Setting.tenantMode);
    if (Setting.tenantMode === 1) {
      var newTenant = util.getTenantByHost();

      if (newTenant === "") {
        next({ name: "login", query: { redirect: to.fullPath } });
        return;
      }
      // 载入租户信息
      await store.dispatch("admin/account/loadTenant");
      var oldTenant = store.state.admin.account.tenant;

      if (oldTenant !== newTenant) {
        //证明是用户直接修改了HOST后 直接访问目标地址，此时将需重新登录
        next({ name: "login", query: { redirect: to.fullPath } });
        return;
      } else {
        console.log('refrashUserInfo')
        // 刷新用户信息
        await refrashUserInfo(to, from, next);
        return;
      }
    } else {
      // 载入租户信息
      let x = await store.dispatch("admin/account/loadTenant");
      console.log("src>router>index.js", `dispatch("admin/account/loadTenant")结果=`, x);
      var tenant = store.state.admin.account.tenant;
      if (tenant === "") {
        next({ name: "login", query: { redirect: to.fullPath } });
        return;
      } else {
        // 刷新用户信息
        await refrashUserInfo(to, from, next);
        return;
      }
    }
  }

  if (to.matched.some(_ => _.meta.auth)) {
    console.log("to.matched.some");
    const token = util.cookies.get("token");
    if (token && token !== "undefined") {
      next();
    } else {
      next({ name: "login", query: { redirect: to.fullPath } });
    }
  } else {
    // 不需要身份校验 直接通过
    next();
  }

});

export default router;
